import styled from '@emotion/styled';

export const HeaderContainer = styled.div`
  height: 100%;
  width: 100%;
  min-height: 80px;
  max-height: 80px;
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette?.common?.white};
  padding: 0px 40px;

    @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints?.values?.tablet + 'px'}){
     padding: 0 12px;
  }
`;

export const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  align-items: center;
`;

export const OptionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 6px;
  cursor: pointer;
  background-color: white;
  padding: 0.8rem;
  border-radius: 100px;
`;
